/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Admin user creation request
 */
export interface AdminUserCreationRequest {
  login: string;
  /**
   * Required only when backoffice single sign-on only mode is disabled
   */
  password?: string;
  /**
   * Only Admin role is allowed.
   */
  adminRole: AdminUserCreationRequest.AdminRoleEnum;
}
export namespace AdminUserCreationRequest {
  export const AdminRoleEnum = {
    Admin: 'ADMIN',
    Client: 'CLIENT',
    ClientApiKey: 'CLIENT_API_KEY',
    AdminRead: 'ADMIN_READ',
    SuperAdmin: 'SUPER_ADMIN',
    AdminCompliance: 'ADMIN_COMPLIANCE',
  } as const;
  export type AdminRoleEnum = (typeof AdminRoleEnum)[keyof typeof AdminRoleEnum];
}
